import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import { DirectoryPage } from "components/DirectoryPage";

export default function PropertiesIndexPage() {
  return <DirectoryPage />;
}

export const getServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...await serverSideTranslations(locale, [
        "marketplace",
        "common",
        "validation",
      ]),
    },
  };
};
